import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { SplitButton } from 'primereact/splitbutton';

export const ButtonsSection = () => {
  const splitButtonItems = [
    { label: 'Update', icon: 'pi pi-refresh' },
    { label: 'Delete', icon: 'pi pi-times' },
    { label: 'Home', icon: 'pi pi-home' },
  ];

  return (
    <div id='buttons' className='space-y-6'>
      <div>
        <h2 className='text-2xl font-bold mb-2'>Buttons</h2>
        <p className='text-gray-600 mb-4'>
          Button components with various styles, severities, and states.
        </p>
      </div>

      {/* Button Variants */}
      <Card title='Button Variants' className='mb-4'>
        <div className='space-y-6'>
          <div>
            <h3 className='text-sm font-semibold mb-3 text-gray-700'>
              Filled (Default)
            </h3>
            <div className='flex flex-wrap gap-3'>
              <Button label='Primary' />
              <Button label='Success' severity='success' />
              <Button label='Info' severity='info' />
              <Button label='Warning' severity='warning' />
              <Button label='Danger' severity='danger' />
              <Button label='Secondary' severity='secondary' />
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-3 text-gray-700'>
              Outlined
            </h3>
            <div className='flex flex-wrap gap-3'>
              <Button label='Primary' outlined />
              <Button label='Success' severity='success' outlined />
              <Button label='Info' severity='info' outlined />
              <Button label='Warning' severity='warning' outlined />
              <Button label='Danger' severity='danger' outlined />
              <Button label='Secondary' severity='secondary' outlined />
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-3 text-gray-700'>Text</h3>
            <div className='flex flex-wrap gap-3'>
              <Button label='Primary' text />
              <Button label='Success' severity='success' text />
              <Button label='Info' severity='info' text />
              <Button label='Warning' severity='warning' text />
              <Button label='Danger' severity='danger' text />
              <Button label='Secondary' severity='secondary' text />
            </div>
          </div>
        </div>
      </Card>

      {/* Button Sizes */}
      <Card title='Button Sizes' className='mb-4'>
        <div className='flex flex-wrap items-center gap-3'>
          <Button label='Small' size='small' />
          <Button label='Normal' />
          <Button label='Large' size='large' />
        </div>
      </Card>

      {/* Button States */}
      <Card title='Button States' className='mb-4'>
        <div className='flex flex-wrap gap-3'>
          <Button label='Normal' />
          <Button label='Disabled' disabled />
          <Button label='Loading' loading />
        </div>
      </Card>

      {/* Buttons with Icons */}
      <Card title='Buttons with Icons' className='mb-4'>
        <div className='space-y-6'>
          <div>
            <h3 className='text-sm font-semibold mb-3 text-gray-700'>
              Icon Position
            </h3>
            <div className='flex flex-wrap gap-3'>
              <Button label='Left Icon' icon='pi pi-check' />
              <Button
                label='Right Icon'
                icon='pi pi-arrow-right'
                iconPos='right'
              />
              <Button icon='pi pi-search' aria-label='Search' />
              <Button icon='pi pi-plus' rounded aria-label='Add' />
              <Button
                icon='pi pi-trash'
                rounded
                outlined
                severity='danger'
                aria-label='Delete'
              />
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-3 text-gray-700'>
              Common Icon Buttons
            </h3>
            <div className='flex flex-wrap gap-3'>
              <Button icon='pi pi-pencil' aria-label='Edit' />
              <Button
                icon='pi pi-trash'
                severity='danger'
                aria-label='Delete'
              />
              <Button
                icon='pi pi-download'
                severity='success'
                aria-label='Download'
              />
              <Button icon='pi pi-upload' severity='info' aria-label='Upload' />
              <Button
                icon='pi pi-cog'
                severity='secondary'
                aria-label='Settings'
              />
              <Button icon='pi pi-refresh' outlined aria-label='Refresh' />
            </div>
          </div>
        </div>
      </Card>

      {/* SplitButton */}
      <Card title='SplitButton' className='mb-4'>
        <div className='flex flex-wrap gap-3'>
          <SplitButton
            label='Save'
            model={splitButtonItems}
            menuButtonProps={{ 'aria-label': 'More save options' }}
          />
          <SplitButton
            label='Save'
            model={splitButtonItems}
            outlined
            menuButtonProps={{ 'aria-label': 'More save options' }}
          />
          <SplitButton
            label='Save'
            model={splitButtonItems}
            severity='success'
            menuButtonProps={{ 'aria-label': 'More save options' }}
          />
          <SplitButton
            label='Save'
            model={splitButtonItems}
            severity='danger'
            outlined
            menuButtonProps={{ 'aria-label': 'More save options' }}
          />
        </div>
      </Card>

      {/* Raised Buttons */}
      <Card title='Raised Buttons' className='mb-4'>
        <div className='flex flex-wrap gap-3'>
          <Button label='Primary' raised />
          <Button label='Success' severity='success' raised />
          <Button label='Info' severity='info' raised />
          <Button label='Warning' severity='warning' raised />
          <Button label='Danger' severity='danger' raised />
        </div>
      </Card>

      {/* Rounded Buttons */}
      <Card title='Rounded Buttons' className='mb-4'>
        <div className='flex flex-wrap gap-3'>
          <Button label='Primary' rounded />
          <Button label='Success' severity='success' rounded />
          <Button label='Info' severity='info' rounded outlined />
          <Button label='Warning' severity='warning' rounded text />
          <Button icon='pi pi-star' rounded />
          <Button icon='pi pi-heart' severity='danger' rounded outlined />
        </div>
      </Card>
    </div>
  );
};
